import { openPanelAnalytics } from "./analyticsServices/openpanel";
import { mixpanelAnalytics } from "./analyticsServices/mixpanel";
import type { BaseAnalyticsServiceObject } from "./analytics.type";
import { devLogger } from "../../common/utils/devLogger";

// TODO: Not used in the project yet. Resolution pending on telemetry

/**
 * Returns a single analytics service object that supports multiple analytics services parallelly
 * @returns BaseAnalyticsServiceObject
 */
const getAnalyticsService = (): BaseAnalyticsServiceObject => {
  const analyticsInstances: BaseAnalyticsServiceObject[] = [];

  if (!!import.meta.env.REACT_APP_OPENPANEL_ANALYTICS_PACKAGE_TOKEN) {
    analyticsInstances.push(openPanelAnalytics());
    devLogger.log("OpenPanel Analytics Service Initialized");
  }
  if (!!import.meta.env.REACT_APP_MIXPANEL_PACKAGE_TOKEN) {
    analyticsInstances.push(mixpanelAnalytics());
    devLogger.log("Mixpanel Analytics Service Initialized");
  }

  return {
    track: (name: string, props?: Record<string, unknown>) => {
      analyticsInstances.forEach(instance => instance.track(name, props));
    },
    identify: (email: string) => {
      analyticsInstances.forEach(instance => instance.identify(email));
    },
    register: (props: Record<string, unknown>) => {
      analyticsInstances.forEach(instance => instance.register(props));
    },
    reset: () => {
      analyticsInstances.forEach(instance => instance.reset());
    }
  };
};

export const analyticsService = getAnalyticsService();
